import React from 'react'
import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'
import useWidth from '@hooks/useWidth'

import styles from './styles.module.css'

const sidebarWidths = {
  sm: 373,
  md: 430,
  lg: 500
}

const largeScreenMultiplier = 1.5

export default function Layout({
  children,
  sidebar,
  sidebarWidth = 'md',
  sidebarPosition = 'right',
  invertColors = false
}: {
  children: React.ReactNode
  sidebar: React.ReactNode
  sidebarWidth?: 'sm' | 'md' | 'lg'
  sidebarPosition?: 'left' | 'right'
  invertColors?: boolean
}) {
  const isDarkMode = useIsDarkMode()
  const screenWidth = useWidth()
  let width
  if (screenWidth >= 1024) width = Math.ceil(sidebarWidths[sidebarWidth] * largeScreenMultiplier)
  else if (screenWidth >= 768) width = sidebarWidths[sidebarWidth]

  return (
    <div
      className={classnames({
        ['bg-gray-100 text-black']: !isDarkMode && !invertColors,
        ['bg-zinc-900 text-white']: isDarkMode && !invertColors,
        ['bg-white']: !isDarkMode && invertColors,
        ['bg-zinc-800']: isDarkMode && invertColors,
        [styles.layout]: true
      })}>
      <div
        className="md:items-center md:min-h-screen"
        style={sidebarPosition === 'right' ? {paddingRight: width} : {paddingLeft: width}}>
        {children}
      </div>
      <div
        style={{width}}
        className={classnames('overflow-auto flex flex-col md:w-100 md:fixed mt-4 md:mt-0 md:inset-y-0 md:p-10 lg:p-20', {
          'md:bg-white': !isDarkMode && !invertColors,
          'md:bg-zinc-800': isDarkMode && !invertColors,
          'md:bg-gray-100 text-black': !isDarkMode && invertColors,
          'md:bg-zinc-900 text-white': isDarkMode && invertColors,
          'md:right-0': sidebarPosition === 'right',
          'md:left-0': sidebarPosition === 'left'
        })}>
        {sidebar}
      </div>
    </div>
  )
}
